var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPastOrderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#052987"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3535 6.6216C19.7092 6.97272 19.7092 7.54686 19.3535 7.89798L9.82252 17.3065C9.43307 17.691 8.80693 17.691 8.41748 17.3065L4.64672 13.5842C4.29091 13.233 4.29091 12.6586 4.64672 12.3074C4.99579 11.9628 5.55691 11.9625 5.90638 12.3066L9.12 15.4715L18.0938 6.6213C18.4431 6.27683 19.0044 6.27696 19.3535 6.6216Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastOrderIcon);
export default __webpack_public_path__ + "static/media/past-order-icon.7b4e2bf2b76c8d54eb2335737793dc48.svg";
export { ForwardRef as ReactComponent };